import { useLang } from "../i18n";
import { useSEO } from "../seo";
import { FadeIn, ParallaxImage, Marquee } from "../components/Reveal";
import { CTAButton, PageHero } from "../components/Bits";

const IMG = {
  hero: "https://images.pexels.com/photos/36570074/pexels-photo-36570074.jpeg?auto=compress&cs=tinysrgb&w=2000",
  detail: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1600&auto=format&fit=crop",
};

const copy = {
  it: {
    seoTitle: "Chi Siamo | Nicole Srl",
    seoDesc: "Nicole Srl: società immobiliare con approccio imprenditoriale. Acquisizioni dirette, valorizzazione e operazioni immobiliari complesse.",
    kicker: "Chi siamo",
    lines: ["Immobiliare.", "Imprenditoriale.", "Concreta."],
    p1: "Nicole Srl nasce con un approccio semplice: individuare immobili con potenziale e trasformarli in operazioni di valore.",
    p2: "Operiamo direttamente nelle acquisizioni immobiliari, nella valorizzazione e nella successiva rivendita, seguendo ogni progetto dalla valutazione iniziale fino al mercato finale.",
    p3: "Una particolare esperienza nelle operazioni immobiliari complesse ci permette inoltre di analizzare situazioni nelle quali una compravendita tradizionale può risultare difficile.",
    quote1: "Ogni immobile ha un valore attuale.",
    quote2: "Il nostro lavoro è capire quale potrebbe diventare.",
    marquee: ["Acquisizione", "Strategia", "Trasformazione", "Valore"],
    cta: "Parlaci del tuo immobile",
  },
  en: {
    seoTitle: "About | Nicole Srl",
    seoDesc: "Nicole Srl: a real estate company with an entrepreneurial approach. Direct acquisitions, value creation and complex real estate operations.",
    kicker: "About us",
    lines: ["Real estate.", "Entrepreneurial.", "Concrete."],
    p1: "Nicole Srl was founded on a simple approach: identifying properties with potential and turning them into valuable operations.",
    p2: "We operate directly in real estate acquisitions, value creation and subsequent resale, following every project from the initial assessment to the final market.",
    p3: "A particular experience in complex real estate operations also allows us to analyse situations in which a traditional sale may prove difficult.",
    quote1: "Every property has a current value.",
    quote2: "Our work is understanding what it could become.",
    marquee: ["Acquisition", "Strategy", "Transformation", "Value"],
    cta: "Tell us about your property",
  },
};

export default function ChiSiamo() {
  const { lang } = useLang();
  const t = copy[lang];
  useSEO({ title: t.seoTitle, description: t.seoDesc, path: "/chi-siamo", lang });

  return (
    <div data-testid="chi-siamo-page">
      <PageHero kicker={t.kicker} lines={t.lines} image={IMG.hero} imageAlt={lang === "it" ? "Facciata neoclassica a Milano" : "Neoclassical facade in Milan"} />

      <section className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36">
        <div className="grid gap-14 md:grid-cols-12">
          <FadeIn className="md:col-span-6">
            <p className="font-serif text-2xl font-light leading-snug md:text-4xl">{t.p1}</p>
          </FadeIn>
          <FadeIn className="md:col-span-4 md:col-start-9" delay={0.15}>
            <p className="text-base leading-relaxed text-stone">{t.p2}</p>
            <p className="mt-6 text-base leading-relaxed text-stone">{t.p3}</p>
          </FadeIn>
        </div>
        <FadeIn delay={0.1}>
          <ParallaxImage
            src={IMG.detail}
            alt={lang === "it" ? "Spazio in trasformazione" : "Space under transformation"}
            className="mt-20 aspect-[16/7] w-full md:mt-28"
          />
        </FadeIn>
      </section>

      <Marquee items={t.marquee} />

      <section className="mx-auto max-w-5xl px-6 py-28 text-center md:px-10 md:py-44">
        <FadeIn>
          <p className="font-serif text-4xl font-light leading-[1.15] tracking-tight md:text-6xl">{t.quote1}</p>
          <p className="mt-4 font-serif text-4xl font-light italic leading-[1.15] tracking-tight text-bronze md:text-6xl">
            {t.quote2}
          </p>
          <div className="mt-14 flex justify-center">
            <CTAButton to="/contatti" variant="dark" testId="chisiamo-cta">
              {t.cta}
            </CTAButton>
          </div>
        </FadeIn>
      </section>
    </div>
  );
}
